/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_RequiredInputs */

const en_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is required.`)
};

const fr_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’e-mail est requis.`)
};

const de_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine E-Mail-Adresse ist erforderlich.`)
};

const it_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'email è obbligatoria.`)
};

const ru_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты обязателен.`)
};

const es_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere correo electrónico.`)
};

const zh_cn2_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必须提供电子邮件地址。`)
};

const ja_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスは必須です。`)
};

const hi_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल की जरूरत है।`)
};

const pt_pt2_team_manager_email_required = /** @type {(inputs: Team_Manager_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário enviar um endereço de e-mail.`)
};

/**
* | output |
* | --- |
* | "Email is required." |
*
* @param {Team_Manager_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_required = /** @type {((inputs?: Team_Manager_Email_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_email_required(inputs)
	if (locale === "de") return de_team_manager_email_required(inputs)
	if (locale === "it") return it_team_manager_email_required(inputs)
	if (locale === "ru") return ru_team_manager_email_required(inputs)
	if (locale === "es") return es_team_manager_email_required(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_email_required(inputs)
	if (locale === "ja") return ja_team_manager_email_required(inputs)
	if (locale === "hi") return hi_team_manager_email_required(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_email_required(inputs)
	return en_team_manager_email_required(inputs)
});